import destination from './components/c-destination';
import destinationSearch from '../../../resources/scripts/components/c-destination';
import datepickerActions from './components/c-datepicker';
import datepickerSelection from '../../../resources/scripts/components/c-datepicker';
import rooms from './components/c-rooms';
import {
  backdropAdd, backdropRemove,
  focusOn,
  widgetClose,
  widgetOpen,
  controlOpen,
  controlClose,
  controlCloseAll,
  isMobile,
  isIOS,
  fixedBodyStyleAddAll,
  fixedBodyStyleRemoveAll,
  updateCatalogOverflowState,
} from '../../../resources/scripts/components/c-common';
import bookingParams from './booking-params';

destination();
destinationSearch();
datepickerSelection();
datepickerActions();
rooms();

// eslint-disable-next-line new-cap
const params = new bookingParams();

const badge = window.document.querySelector('.js-booking-badge');
const widget = window.document.querySelector('.js-booking-widget');
const openTriggers = window.document.querySelectorAll('.js-booking-badge, .header__cta');
const closeTriggers = window.document.querySelectorAll('.js-booking-close');

const SCROLL_LOCK_OWNER = 'booking-widget';

let isOpening = false;
let savedScrollPosition = 0;

function closeBookingWidget() {
  if (!widget) {
    return;
  }

  controlCloseAll(widget);
  widgetClose(widget);
  params.clearErrors();
  backdropRemove();

  if (isMobile()) {
    fixedBodyStyleRemoveAll(SCROLL_LOCK_OWNER);
  }
}

openTriggers.forEach((el) => {
  el.addEventListener('click', () => {
    isOpening = true;
    savedScrollPosition = window.scrollY;
    widgetOpen(widget);
    backdropAdd();

    setTimeout(() => {
      window.scrollTo(0, savedScrollPosition);
      isOpening = false;

      const firstTrigger = widget.querySelector('.js-control-trigger');
      if (firstTrigger) {
        firstTrigger.focus();
      }
    }, 50);
  });
});

closeTriggers.forEach((el) => {
  el.addEventListener('click', () => {
    closeBookingWidget();
  });
});

window.addEventListener('scroll', () => {
  if (isOpening) {
    return;
  }

  if (window.scrollY > 10) {
    badge?.classList.add('scroll');
  } else {
    badge?.classList.remove('scroll');
  }
});

const controlTriggers = widget ? widget.querySelectorAll('.js-control-trigger') : [];

function handleControlTrigger(event) {
  const { target } = event;
  const control = target.closest('.js-booking-widget-control');
  if (!control) return;

  const dataInput = target.dataset.input;
  const input = control.querySelector(`.${dataInput}`);

  // Close other dropdowns and open the current one
  controlCloseAll(widget);
  controlOpen(control);

  // Mobile: do not focus the destination search on open, or the OS keyboard covers the hotel list.
  const skipMobileSearchFocus = isMobile() && input?.classList.contains('js-catalog-search');
  if (input && !skipMobileSearchFocus) {
    focusOn(input);
    input.focus();
  }

  if (!widget.classList.contains('open')) {
    isOpening = true;
    savedScrollPosition = window.scrollY;
    widgetOpen(widget);
    backdropAdd();

    setTimeout(() => {
      window.scrollTo(0, savedScrollPosition);
      isOpening = false;
    }, 50);
  }

  if (isMobile() && isIOS) {
    fixedBodyStyleAddAll(SCROLL_LOCK_OWNER);
  }

  updateCatalogOverflowState(widget, '.js-control-container');
}

controlTriggers.forEach((trigger) => {
  trigger.addEventListener('click', handleControlTrigger);

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleControlTrigger(event);
    }
  });
});

widget?.querySelectorAll('.js-control-back').forEach((el) => {
  el.addEventListener('click', (event) => {
    const control = event.target.closest('.js-booking-widget-control, .js-control');
    if (!control) {
      return;
    }

    controlClose(control);
    control.querySelector('.js-control-trigger')?.focus();
  });
});

let ignoreWidgetFocusout = false;

if (widget) {
  widget.addEventListener('mousedown', () => {
    ignoreWidgetFocusout = true;
    setTimeout(() => {
      ignoreWidgetFocusout = false;
    });
  });

  widget.addEventListener('focusout', () => {
    if (ignoreWidgetFocusout) {
      return;
    }

    setTimeout(() => {
      if (widget.dataset.bookingWidgetIgnoreFocusout === '1') {
        return;
      }

      const focused = document.activeElement;
      if (!focused || widget.contains(focused)) {
        return;
      }

      closeBookingWidget();
    }, 0);
  });
}

window.document.addEventListener('click', (event) => {
  const { target } = event;
  const closest = target.closest('.js-booking-widget-control, .js-booking-badge, .js-booking-widget-widget');
  if (closest === null) {
    closeBookingWidget();
  }

  if (target.closest('.header__cta')) {
    isOpening = true;
    savedScrollPosition = window.scrollY;
    widgetOpen(widget);
    backdropAdd();

    setTimeout(() => {
      window.scrollTo(0, savedScrollPosition);
      isOpening = false;
    }, 50);

    if (isMobile() && isIOS) {
      fixedBodyStyleAddAll(SCROLL_LOCK_OWNER);
    }
  }
});

const isMobileAgent = navigator.userAgentData?.mobile
  ?? /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);

if (isMobileAgent) {
  document.addEventListener('touchstart', (e) => {
    const catalogContainer = e.target.closest('.c-destination__catalog-container');
    if (catalogContainer) {
      const searchInput = catalogContainer
        .closest('.js-control-container')
        ?.querySelector('.js-catalog-search');
      if (searchInput) {
        searchInput.blur();
      }
    }
  }, { passive: true });
}

if (isIOS) {
  document.addEventListener('touchmove', (e) => {
    const bookingWidget = window.document.querySelector('.js-booking-widget');
    if (bookingWidget && bookingWidget.classList.contains('open')) {
      const controlContainer = e.target.closest('.js-control-container');
      const catalogContainer = e.target.closest('.c-destination__catalog-container');
      const datepickerBody = e.target.closest('.c-datepicker__body');

      if (catalogContainer && !catalogContainer.classList.contains('no-scroll')) {
        const canScroll = catalogContainer.scrollHeight > catalogContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      if (datepickerBody && !datepickerBody.classList.contains('no-scroll')) {
        const canScroll = datepickerBody.scrollHeight > datepickerBody.clientHeight;
        if (canScroll) {
          return;
        }
      }

      if (controlContainer && !controlContainer.classList.contains('no-scroll')) {
        const canScroll = controlContainer.scrollHeight > controlContainer.clientHeight;
        if (canScroll) {
          return;
        }
      }

      e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('focusin', (event) => {
    if (event.target.matches('input[type="text"], input[type="search"], textarea')) {
      const bookingWidget = window.document.querySelector('.js-booking-widget');
      if (bookingWidget && bookingWidget.classList.contains('open')) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 100);
      }
    }
  });

  document.addEventListener('focusout', (event) => {
    if (event.target.matches('input[type="text"], input[type="search"], textarea')) {
      setTimeout(() => {
        const bookingWidget = window.document.querySelector('.js-booking-widget');
        if (bookingWidget && bookingWidget.classList.contains('open')) {
          if (bookingWidget.dataset.bookingWidgetIgnoreFocusout === '1') {
            return;
          }

          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;

          fixedBodyStyleAddAll(SCROLL_LOCK_OWNER);
        }
      }, 300);
    }
  });
}

document.addEventListener('input', (event) => {
  const { target } = event;
  if (target && target.classList && target.classList.contains('js-catalog-search')) {
    updateCatalogOverflowState(widget, '.js-control-container');
  }
});

window.addEventListener('resize', () => {
  const openedControl = window.document.querySelector('.js-control-container.open');
  const mobileViewport = isMobile();

  if (!mobileViewport) {
    fixedBodyStyleRemoveAll(SCROLL_LOCK_OWNER);
  }

  if (!openedControl && !mobileViewport) {
    closeBookingWidget();
  } else if (widget.classList.contains('open') && mobileViewport && isIOS) {
    fixedBodyStyleAddAll(SCROLL_LOCK_OWNER);
  }

  updateCatalogOverflowState(widget, '.js-control-container');
});
